export default __webpack_public_path__ + "static/media/43-min.e4c7a748.png";